<template>
  <div class="card" :class="{ 'card-expand': expanded }">
    <div class="card-header">
      {{$t('sms.infos.outgoing-component.title')}} <!-- Mensagens por Status -->
      <ul class="actions top-right">
        <li>
          <a href="javascript:void(0)" @click="changeChart">
            <i v-if="type == 'line'" class="icon dripicons-graph-pie"></i>
            <i v-else-if="type == 'pie'" class="icon dripicons-graph-line"></i>
          </a>
        </li>
        <li>
          <a href="javascript:void(0)" @click="fetch">
            <i class="icon dripicons-clockwise"></i>
          </a>
        </li>
        <li>
          <a href="javascript:void(0)" @click="expand">
            <i v-if="expanded" class="icon dripicons-contract-2"></i>
            <i v-else class="icon dripicons-expand-2"></i>
          </a>
        </li>
      </ul>
    </div>
    <div class="block-el">
      <template v-if="fetched">
        <div class="card-body">
          <div class="row m-0 col-border-xl">
            <div class="col-md-2 p-20">
              <h6>{{$t('sms.infos.outgoing-component.lbl-total')}}</h6> <!-- Total de Mensagens -->
              <span class="h3 text-primary">{{ total }}</span>
              <template v-if="delivered">
                <h6 class="m-t-20">{{$tc('generic-str.delivered', 2)}}</h6><!-- Entregues -->
                <span class="h3 text-success">{{ delivered }}</span>
              </template>
              <template v-if="undelivered">
                <h6 class="m-t-20">{{$tc('generic-str.unavailable', 2)}}</h6><!-- Indisponíveis -->
                <span class="h3 text-dark">{{ undelivered }}</span>
              </template>
              <template v-if="failed">
                <h6 class="m-t-20">{{$tc('generic-str.failure', 2)}}</h6><!-- Falhas -->
                <span class="h3 text-danger">{{ failed }}</span>
              </template>
              <template v-if="sent">
                <h6 class="m-t-20">{{$tc('generic-str.sent-a', 2)}}</h6><!-- Enviadas -->
                <span class="h3 text-info">{{ sent }}</span>
              </template>
            </div>
            <div class="col-md-10">
              <template v-if="total">
                <line-chart
                  v-if="type === 'line'"
                  :chartdata="line.chartdata"
                  :options="line.options"
                  :height="chartHeight"
                />
                <doughnut-chart
                  v-else-if="type === 'pie'"
                  :chartdata="pie.chartdata"
                  :options="pie.options"
                  :height="chartHeight"
                />
              </template>
              <div v-else class="text-center table-placeholder">
                <i class="far fa-chart-bar font-size-80"></i>
                <h5 class="card-title m-t-20">{{$t('sms.infos.none')}}</h5><!-- Nenhum resultado encontrado -->
                <p>{{$t('sms.infos.none-msg')}}</p><!-- Nenhum dado de mensagem corresponde aos seus critérios de filtragem. Tente ajustar seus filtros. -->
              </div>
            </div>
          </div>
        </div>
      </template>
      <div v-else class="qt-block-ui" />
    </div>
  </div>
</template>

<script>
import SmsService from '@/services/sms.service';
import LineChart from '@/components/LineChart.vue';
import DoughnutChart from '@/components/DoughnutChart.vue';

export default {
  name: 'OutgoingCard',
  components: { LineChart, DoughnutChart },
  props: ['form', 'filters'],
  data() {
    return {
      chartHeight: window.innerWidth >= 768 ? 102 : 468,
      fetched: true,
      expanded: false,
      type: 'line',
      total: 0,
      delivered: 0,
      undelivered: 0,
      failed: 0,
      sent: 0,
      line: {
        chartdata: {
          labels: [],
          datasets: [],
        },
        options: {
          responsive: true,
          scales: {
            yAxes: [
              {
                ticks: {
                  precision: 0,
                },
              },
            ],
            xAxes: [
              {
                type: 'time',
                time: {
                  unit: 'hour',
                  displayFormats: {
                    day: 'DD/MM',
                    hour: 'HH:mm:ss',
                  },
                },
                ticks: {
                  autoSkip: true,
                  maxTicksLimit: 7,
                },
              },
            ],
          },
        },
      },
      pie: {
        chartdata: {
          labels: [],
          datasets: [
            {
              backgroundColor: [],
              data: [],
            },
          ],
        },
        options: {
          responsive: true,
        },
      },
    };
  },
  created() {
    if (window.innerWidth >= 1920) {
      this.chartHeight = 102;
    } else if (window.innerWidth >= 1280) {
      this.chartHeight = 174;
    } else if (window.innerWidth >= 768) {
      this.chartHeight = 244;
    } else {
      this.chartHeight = 466;
    }
    // this.fetch();
  },
  methods: {
    fetch() {
      this.fetched = false;
      this.line.chartdata.labels = [];
      this.line.chartdata.datasets = [];
      this.pie.chartdata.labels = [];
      this.pie.chartdata.datasets.backgroundColor = [];
      this.pie.chartdata.datasets.data = [];
      this.delivered = 0;
      this.undelivered = 0;
      this.failed = 0;
      this.sent = 0;
      this.total = 0;

      const unit = this.form.time_window === 'daily' ? 'day' : 'hour';
      this.line.options.scales.xAxes[0].time.unit = unit;

      const filter = {
        filters: this.filters,
        ...this.form,
        group_by: 'status',
        direction: 'outbound',
      };
      SmsService.getInsights({
        filters: this.filters,
        ...this.form,
        group_by: 'status',
        direction: 'both',
      })
        .then(
          (response) => {
            response.forEach((element) => {
              Object.keys(element.values).forEach((status, i) => {
                const value = element.values[status];
                if (!this.line.chartdata.datasets[i]) {
                  let color = '';
                  let label = '';
                  if (status === 'delivered') {
                    color = '#2fbfa0';
                    label = this.$tc('generic-str.delivered', 2); // Entregues
                  } else if (status === 'undelivered') {
                    color = '#15182b';
                    label = this.$tc('generic-str.unavailable', 2); // Indisponíveis
                  } else if (status === 'failed') {
                    color = '#ff5c75';
                    label = this.$tc('generic-str.failure', 2); // Falhas
                  } else if (status === 'sent') {
                    color = '#399AF2';
                    label = this.$tc('generic-str.sent-a', 2); // Enviadas
                  } else if (status === 'received') {
                    color = '#ccc';
                    label = this.$tc('sms.infos.incoming-component.received', 2); // Recebidas
                  }
                  this.line.chartdata.datasets[i] = {
                    label,
                    borderColor: color,
                    data: [value],
                    fill: false,
                    lineTension: 0.1,
                  };
                  this.pie.chartdata.labels.push(label);
                  this.pie.chartdata.datasets[0].backgroundColor[i] = color;
                  this.pie.chartdata.datasets[0].data[i] = value;
                } else {
                  this.line.chartdata.datasets[i].data.push(value);
                  this.pie.chartdata.datasets[0].data[i] += value;
                }
                if (status === 'delivered') {
                  this.delivered += value;
                } else if (status === 'undelivered') {
                  this.undelivered += value;
                } else if (status === 'failed') {
                  this.failed += value;
                } else if (status === 'sent') {
                  this.sent += value;
                }
                this.total += value;
              });
              this.line.chartdata.labels.push(element.date_time);
            });
          },
          (error) => {
            this.content = error;
          },
        )
        .finally(() => {
          this.fetched = true;
        });
    },
    changeChart() {
      this.type = this.type === 'pie' ? 'line' : 'pie';
    },
    expand() {
      this.expanded = !this.expanded;
    },
  },
};
</script>

<style scoped lang="scss">
.block-el {
  min-height: 200px;
}
</style>
